module.exports = __webpack_public_path__ + "img/transparent-white.c16319e8.png";